import React from 'react';
import PropTypes from 'prop-types';
import Switch from 'react-switch';
import cn from 'classnames';
import SearchIcon from '@material-ui/icons/Search';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

import './CallsFilters.scss';

const CallsFilters = (props) => {
  const {
    changeSearch,
    searchVal,
    toggleFilters,
    filtersVisible,
    toggleShowOnlyUnmatchedCards,
    showOnlyUnmatched,
    setSelectedHealthScore,
    selectedHealthScore,
  } = props;
  return (
    <div className={cn('calls-filters-outer-container', { collapsed: !filtersVisible })}>
      <div onClick={toggleFilters} className='filter-and-search-toggle'>
        <KeyboardArrowLeft className='close' />
        FILTER & SEARCH
        <KeyboardArrowRight className='open' />
      </div>
      <div className='search-section section'>
        <SearchIcon />
        <input placeholder='Search Calls or Participants' value={searchVal} onChange={(e) => changeSearch(e.target.value)} />
      </div>
      <div className='good-bad-section section'>
        <div className='section-header'>HEALTH SCORE</div>
        <div className='options'>
          <div onClick={() => setSelectedHealthScore(null)} className={cn('option all', { selected: !selectedHealthScore })}>
            All
          </div>
          <div onClick={() => setSelectedHealthScore('Low')} className={cn('option low', { selected: selectedHealthScore === 'Low' })}>
            Low
          </div>
          <div onClick={() => setSelectedHealthScore('Medium')} className={cn('option medium', { selected: selectedHealthScore === 'Medium' })}>
            Medium
          </div>
          <div onClick={() => setSelectedHealthScore('High')} className={cn('option high', { selected: selectedHealthScore === 'High' })}>
            High
          </div>
        </div>
      </div>
      {window.__ALLOW_DEALS__ && (
        <div onClick={toggleShowOnlyUnmatchedCards} className='toggle-row toggle-show-unmatched-cards'>
          <div>Only Show Unmatched Calls</div>
          <Switch
            onChange={() => {}}
            checked={showOnlyUnmatched}
            height={20}
            width={36}
            onColor='#333'
            offColor='#ddd'
            className='switch'
            checkedIcon={false}
            uncheckedIcon={false}
          />
        </div>
      )}
    </div>
  );
};

CallsFilters.propTypes = {
  toggleFilters: PropTypes.func.isRequired,
  changeSearch: PropTypes.func.isRequired,
  searchVal: PropTypes.string.isRequired,
  filtersVisible: PropTypes.bool.isRequired,
  setSelectedHealthScore: PropTypes.func.isRequired,
  selectedHealthScore: PropTypes.string,
};

export default CallsFilters;
